import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { PrDetailsComponent } from '../../shared/containers/modals/pr-details/pr-details.component';
import { IBuyerRC, ILineItemDetail, IPurchaseRequest_FLAT, IPurchaseRequest } from '../../shared/models';
import { CustomFormFieldService } from '../../shared/services/form-field.service';
import { LineItemCreateComponent } from '../components/modals/line-item-create/line-item-create.component';
import { PR_DETAILS_FORMFIELDS } from '../constants/pr-details-form-fields.constant';
import { PR_ACCOUNT_DETAILS_FORMFIELDS, PR_MATERIAL_MASTER_FORMFIELDS, PR_RC_DETAILS_FORMFIELDS, PR_VENDOR_DETAILS_FORMFIELDS } from '../constants/pr-line-item-form-fields.constant';
import { RejectRemarksComponent } from '../../dashboard/containers/pr-reporting-manager/components/reject-remarks/reject-remarks.component';
@Injectable({
  providedIn: 'root'
})
export class PrInitiatorHelperService {

  constructor(private _formBuilder : FormBuilder,
    private modalService : BsModalService,
    private _formFieldService : CustomFormFieldService,
    private _hhtp: HttpClient) { }

  public formatFileSize = (bytes : any, decimals = 2) : string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public readExcel(file: File): Promise<XLSX.WorkBook> {
    return new Promise<XLSX.WorkBook>((resolve) => {
      const reader = new FileReader()
      reader.onload = (e : any) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        resolve(workbook)
      }
      reader.onerror = (err) => {
      };
      reader.readAsBinaryString(file)
    })
  }

  public populateGrid(workbook: XLSX.WorkBook): Array<IPurchaseRequest_FLAT> {
    // Data is in the first sheet
    var firstSheetName = workbook.SheetNames[0];
    var worksheet = workbook.Sheets[firstSheetName];

    // Expecting the following columns to be present
    var columns: any = {
      A: "PR Number",
      B: "PR Date",
      C: "PR Description",
      D: "Purchasing Organization",
      E: "Employee Code",
      F: "Company Code  ",
      G: "Purchasing Group",
      H: "Plant",
      I: "Recipient",
      J: "Registered Email1",
      K: "Registered Email2",
      L: "Bill To",
      M: "Delivery Address Title",
      N: "Delivery Address Name",
      O: "Delivery Address Name_1",
      P: "Street or house Number",
      Q: "District",
      R: "Postal Code",
      S: "Line Item Number",
      T: "Item Category",
      U: "Material Code",
      V: "Item description",
      W: "Short Text",
      X: "Material Group",
      Y: "Quantity",
      Z: "Ordering Unit",
      AA: "Price",
      AB: "Currency",
      AC: "Delivery Date",
      AD: "Warranties",
      AE: "PO Text",
      AF: "Asset Number",
      AG: "gl Account",
      AH: "eval group",
      AI: "Vendor Code",
      AJ: "Vendor Name",
      AK: "Vendor Location"
    }

    var rowData = [];

    // start at the 2nd row - the first row are the headers
    var rowIndex = 2;

    // iterate over the worksheet pulling out the columns we're expecting
    while (worksheet['A' + rowIndex]) {
      var row: any = {};
      Object.keys(columns).forEach(function (column) {
        row[columns[column]] = worksheet[column + rowIndex] ? worksheet[column + rowIndex].w : null;
      });
      rowData.push(row);
      rowIndex++;
    }
    return rowData;
  }

  public validateExcel(workbook: XLSX.WorkBook): boolean {
    const Strings = (workbook as any).Strings;
    try {
      if (
        // worksheet["A1"].v.toLowerCase().trim() === "pr_number" &&
        // worksheet["A2"].v.toLowerCase().trim() === "purchasing_organization" &&
        // worksheet["A3"].v.toLowerCase().trim() === "currency" &&
        // worksheet["A4"].v.toLowerCase().trim() === "employee_code" &&
        // worksheet["A5"].v.toLowerCase().trim() === "line_item_number" &&
        // worksheet["A6"].v.toLowerCase().trim() === "account_assignment_category" &&
        // worksheet["A7"].v.toLowerCase().trim() === "item_category" &&
        // worksheet["A8"].v.toLowerCase().trim() === "quantity" &&
        // worksheet["A9"].v.toLowerCase().trim() === "ordering_unit" &&
        // worksheet["A10"].v.toLowerCase().trim() === "delivery_date" &&
        // worksheet["A11"].v.toLowerCase().trim() === "uom" &&
        // worksheet["A12"].v.toLowerCase().trim() === "matl_group" &&
        // worksheet["A13"].v.toLowerCase().trim() === "plant" &&
        // worksheet["A14"].v.toLowerCase().trim() === "gl_account" &&
        // worksheet["A15"].v.toLowerCase().trim() === "multple_account" &&
        // worksheet["A16"].v.toLowerCase().trim() === "wbs_element" &&
        // worksheet["A17"].v.toLowerCase().trim() === "cost_center" &&
        // worksheet["A18"].v.toLowerCase().trim() === "asset_number" &&
        // worksheet["A19"].v.toLowerCase().trim() === "order_number" &&
        // worksheet["A20"].v.toLowerCase().trim() === "sales_order" &&
        // worksheet["A21"].v.toLowerCase().trim() === "sales_item_no" &&
        // worksheet["A22"].v.toLowerCase().trim() === "recipient" &&
        // worksheet["A23"].v.toLowerCase().trim() === "registered_email1" &&
        // worksheet["A24"].v.toLowerCase().trim() === "registered_email2" &&
        // worksheet["A25"].v.toLowerCase().trim() === "attachment_path" &&
        // worksheet["A26"].v.toLowerCase().trim() === "pr_item"

        // Strings[0].h.toLowerCase().trim() === "pr number" &&
        Strings[0].h.toLowerCase().trim() === "pr number" &&
        Strings[1].h.toLowerCase().trim() === "pr date" &&
        Strings[2].h.toLowerCase().trim() === "pr description" &&
        Strings[3].h.toLowerCase().trim() === "purchasing organization" &&
        Strings[4].h.toLowerCase().trim() === "employee code" &&
        Strings[5].h.toLowerCase().trim() === "company code" &&
        Strings[6].h.toLowerCase().trim() === "purchasing group" &&
        Strings[7].h.toLowerCase().trim() === "plant" &&
        Strings[8].h.toLowerCase().trim() === "recipient" &&
        Strings[9].h.toLowerCase().trim() === "registered email1" &&
        Strings[10].h.toLowerCase().trim() === "registered email2" &&
        Strings[11].h.toLowerCase().trim() === "bill to" &&
        Strings[12].h.toLowerCase().trim() === "delivery address title" &&
        Strings[13].h.toLowerCase().trim() === "delivery address name" &&
        Strings[14].h.toLowerCase().trim() === "delivery address name_1" &&
        Strings[15].h.toLowerCase().trim() === "street or house number" &&
        Strings[16].h.toLowerCase().trim() === "district" &&
        Strings[17].h.toLowerCase().trim() === "postal code" &&
        Strings[18].h.toLowerCase().trim() === "line item number" &&
        Strings[19].h.toLowerCase().trim() === "item category" &&
        Strings[20].h.toLowerCase().trim() === "material code" &&
        Strings[21].h.toLowerCase().trim() === "item description" &&
        Strings[22].h.toLowerCase().trim() === "short text" &&
        Strings[23].h.toLowerCase().trim() === "material group" &&
        Strings[24].h.toLowerCase().trim() === "quantity" &&
        Strings[25].h.toLowerCase().trim() === "ordering unit" &&
        Strings[26].h.toLowerCase().trim() === "price" &&
        Strings[27].h.toLowerCase().trim() === "currency" &&
        Strings[28].h.toLowerCase().trim() === "delivery date" &&
        Strings[29].h.toLowerCase().trim() === "warranties" &&
        Strings[30].h.toLowerCase().trim() === "asset number" &&
        Strings[31].h.toLowerCase().trim() === "gl account" &&
        Strings[32].h.toLowerCase().trim() === "eval group" &&
        Strings[33].h.toLowerCase().trim() === "vendor code" &&
        Strings[34].h.toLowerCase().trim() === "vendor name" &&
        Strings[35].h.toLowerCase().trim() === "vendor location" &&
        Strings[36].h.toLowerCase().trim() === "division" &&
        Strings[37].h.toLowerCase().trim() === "esn"
      )
        return true;
      else
        return false;
    }
    catch (error) {
      return false;
    }
  }

  public removeDuplicates<T, Key extends keyof T>(array1 : Array<T>, array2 : Array<T>, key : Key) : Array<T> {
    for( var i=array1.length - 1; i>=0; i--){
      for( var j=0; j<array2.length; j++){
        if(array1[i] && (array1[i][key] === array2[j][key])){
          array1.splice(i, 1);
        }
      }
    }
    return array1
  }

  // Updated PR creation form //
  public getPRDetailsForm() : FormGroup {
    return this._formFieldService.createFormGroup(PR_DETAILS_FORMFIELDS);
  }

  public getPRLineItemMaterialMasterForm() : FormGroup {
    return this._formFieldService.createFormGroup(PR_MATERIAL_MASTER_FORMFIELDS);
  }

  public getPRLineItemAccountDetailForm() : FormGroup {
    return this._formFieldService.createFormGroup(PR_ACCOUNT_DETAILS_FORMFIELDS);
  }

  public getPRLineItemVendorDetailForm() : FormGroup {
    return this._formFieldService.createFormGroup(PR_VENDOR_DETAILS_FORMFIELDS);
  }

  public getPRLineItemRCDetailForm() : FormGroup {
    return this._formFieldService.createFormGroup(PR_RC_DETAILS_FORMFIELDS);
  }

  public openLineItemModal(purchaseRequestForm : FormGroup, lineItemDetail : ILineItemDetail | any | null, rcList : Array<IBuyerRC> = [],isMRPPr?:boolean,withRC:boolean=false) : Observable<any> {
    const initialState: ModalOptions<any> = {
      initialState: {
        title : "Add new line item",
        purchaseRequestForm,
        lineItemDetail,
        rcList,
        isMRPPr,
        withRC
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this.modalService.show(LineItemCreateComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openRemarks(payload:any): any {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: "Remarks",
        payload:payload
      },
      backdrop: 'static',
      class : 'modal-lg'
    };
    return this.modalService.show(RejectRemarksComponent, initialState);
  }

  // Doing object manipulation here, instead need to modify the formfield service to return data in nested object form; TBD
  public getPRModel(formGroup : FormGroup, prLineItems : Array<ILineItemDetail> = []) : IPurchaseRequest {
    let purchaseRequest = formGroup.value;
    purchaseRequest.line_items = prLineItems;
    purchaseRequest.line_items.forEach((x : ILineItemDetail) => {
      if(x.material_master?.esn) x.material_master.matl_group = x.material_master?.esn;
    })
    purchaseRequest.address = {
      delivery_address_title: formGroup.value.delivery_address_title,
      delivery_address_name:  formGroup.value.delivery_address_name ,
      delivery_address_name_1: formGroup.value.delivery_address_name_1,
      street_or_house_number: formGroup.value.street_or_house_number,
      district: formGroup.value.district,
      postal_code: formGroup.value.postal_code,
      city : formGroup.value.city,
      country : formGroup.value.country,
      region : formGroup.value.region
    }
    purchaseRequest.pr_number = isNaN(parseInt(purchaseRequest.pr_number)) ? purchaseRequest.pr_number : parseInt(purchaseRequest.pr_number);
    const { delivery_address_title, delivery_address_name, delivery_address_name_1, street_or_house_number , district, postal_code , city, country, region, ...updatedPR } = purchaseRequest;
    console.log("updatedPRupdatedPR",updatedPR)
    return updatedPR;
  }
  
  public getColumnDef() : Array<any>{
    //IMP - Need to change the filedname binding later ****
    const columnDefs = [
      {
        groupId: 'prGroup',
        headerName: 'PR Data',
        children: [
          { headerName: 'PR #', field:'pr_number', pinned: 'left', resizable: true, filter: true, checkboxSelection: true, headerCheckboxSelection: true },
          { headerName: 'Submission Date', field:'pr_date', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed', cellRenderer: (data: any) => {
            return data.value ? (new Date(data.value)).toLocaleDateString() : '';
          }},
          { headerName: 'Reference #', field:'reference_number', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed'},
          { headerName: 'Aging', field:'aging', pinned: 'left', resizable: true, filter: true, columnGroupShow: 'closed'},
          ],
      },
      {
        groupId: 'basicDetails',
        headerName: 'Basic Details',
        field:'line_items',
        children: [
          { headerName: 'Purchasing Organization', field:'purchasing_organization',resizable: true, filter: true},
          { headerName: 'Currency', field:'line_items[0].material_master.currency',resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Line Item #', field:'line_items[0].material_master.line_item_number',resizable: true, filter: true, columnGroupShow: 'closed'}, 
          { headerName: 'Account Assignment Category', field:'accountAssignmentCategory',resizable: true, filter: true, columnGroupShow: 'closed' }, 
          { headerName: 'Item Category', field:'line_items[0].material_master.item_category',resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Quantity ', field:'line_items[0].material_master.quantity',resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Ordering Unit', field:'line_items[0].material_master.ordering_unit',resizable: true, filter: true, columnGroupShow: 'closed' },
          { headerName: 'Delivery date ', field:'line_items[0].material_master.delivery_date',resizable: true, filter: true, columnGroupShow: 'closed', cellRenderer: (data: any) => {
            return data.value ? (new Date(data.value)).toLocaleDateString() : '';
          } },
          
        ],
      },
      {
        groupId: 'prActionGroup',
        headerName: '',
        children: [
          { headerName: 'Status', pinned: 'right', field:'status',resizable: true, filter: true },
          { 
            headerName: 'Actions', pinned: 'right', resizable: true, filter: true, 
            cellRenderer: 'AgGridActionsRendererComponent',
            cellRendererParams: [
              { name:"View PR", icon:"fa-eye" },
              { name:"Edit PR", icon:"fa-edit" },
              { name:"Forward Request", icon:"fa-forward" },
              { name:"Approve/Reject", icon:"fa-check" }],
            cellEditor: 'AgGridActionsWrapperComponent',
            cellEditorPopup: true,
            singleClickEdit: true,
            editable: true,
          },
        ],
      }
    ];
    return columnDefs;
  }

  public openPRDetailsModal(purchaseRequest : IPurchaseRequest) : Observable<any> {
    const initialState: ModalOptions<any> = {
      initialState: {
        title : `Purchase Request Details : ${purchaseRequest.pr_number}`,
        purchaseRequest
      },
      backdrop: 'static',
      class : 'modal-xl'
    };
    const bsModalRef : BsModalRef = this.modalService.show(PrDetailsComponent, initialState);
    return bsModalRef.content.onClose
  }

  public getFilterParams<T>(rcFilters : T) : string {
    let query = "";
    Object.keys(rcFilters).forEach(element => {
      let value  = rcFilters ? rcFilters[element as keyof T] : null;
      query = query + `${element}=${value}&`
    });
    return query
  }

}
